import React from 'react';
import { Upload, FileText, Calendar, Clock, CheckCircle2, ChevronDown, Wallet, DollarSign, TrendingUp, BarChart3, Building2, Info } from 'lucide-react';
import { BarChart, Bar, LineChart, Line, AreaChart, Area, PieChart, Pie, Cell, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
// Card Revenue Data - Showing decline from $1.5M/month to $1.0M/month
const cardRevenueData = [{
  month: 'Jan-24',
  revenue: 1.45
}, {
  month: 'Feb-24',
  revenue: 1.48
}, {
  month: 'Mar-24',
  revenue: 1.52
}, {
  month: 'Apr-24',
  revenue: 1.5
}, {
  month: 'May-24',
  revenue: 1.54
}, {
  month: 'Jun-24',
  revenue: 1.56
}, {
  month: 'Jul-24',
  revenue: 1.58
}, {
  month: 'Aug-24',
  revenue: 1.52
}, {
  month: 'Sep-24',
  revenue: 1.48
}, {
  month: 'Oct-24',
  revenue: 1.42
}, {
  month: 'Nov-24',
  revenue: 1.35
}, {
  month: 'Dec-24',
  revenue: 1.28
}, {
  month: 'Jan-25',
  revenue: 1.22
}, {
  month: 'Feb-25',
  revenue: 1.15
}, {
  month: 'Mar-25',
  revenue: 1.08
}, {
  month: 'Apr-25',
  revenue: 1.54
}, {
  month: 'May-25',
  revenue: 1.52
}, {
  month: 'Jun-25',
  revenue: 1.5
}, {
  month: 'Jul-25',
  revenue: 1.48
}, {
  month: 'Aug-25',
  revenue: 1.42
}, {
  month: 'Sep-25',
  revenue: 1.35
}, {
  month: 'Oct-25',
  revenue: 1.28
}, {
  month: 'Nov-25',
  revenue: 1.18
}, {
  month: 'Dec-25',
  revenue: 1.08
}, {
  month: 'Jan-26',
  revenue: 1.02
}, {
  month: 'Feb-26',
  revenue: 0.98
}, {
  month: 'Mar-26',
  revenue: 0.95
}];
// Days Beyond Terms Data - Showing spike from 15 to 45 days
const dbtData = [{
  month: 'Apr-25',
  dbt: 15,
  industry: 12,
  yourAR: 12
}, {
  month: 'May-25',
  dbt: 16,
  industry: 11,
  yourAR: 14
}, {
  month: 'Jun-25',
  dbt: 18,
  industry: 12,
  yourAR: 16
}, {
  month: 'Jul-25',
  dbt: 20,
  industry: 12,
  yourAR: 18
}, {
  month: 'Aug-25',
  dbt: 24,
  industry: 13,
  yourAR: 22
}, {
  month: 'Sep-25',
  dbt: 28,
  industry: 13,
  yourAR: 26
}, {
  month: 'Oct-25',
  dbt: 32,
  industry: 14,
  yourAR: 30
}, {
  month: 'Nov-25',
  dbt: 36,
  industry: 14,
  yourAR: 34
}, {
  month: 'Dec-25',
  dbt: 38,
  industry: 15,
  yourAR: 36
}, {
  month: 'Jan-26',
  dbt: 42,
  industry: 15,
  yourAR: 40
}, {
  month: 'Feb-26',
  dbt: 44,
  industry: 16,
  yourAR: 42
}, {
  month: 'Mar-26',
  dbt: 45,
  industry: 16,
  yourAR: 44
}];
// Trade Payment Aging Data - Showing severe past due
const paidData = [{
  name: 'Current',
  value: 3200000
}, {
  name: '1-30',
  value: 1800000
}, {
  name: '31-60',
  value: 950000
}, {
  name: '61-90',
  value: 620000
}, {
  name: '91+',
  value: 430000
}];
const outstandingData = [{
  name: 'Current',
  value: 280000
}, {
  name: '1-30',
  value: 350000
}, {
  name: '31-60',
  value: 480000
}, {
  name: '61-90',
  value: 420000
}, {
  name: '91+',
  value: 280000
}];
// Trade Spend by Industry Data - IT/Software focus
const tradeSpendData = [{
  name: 'IT & Technology',
  value: 620000,
  color: '#4f46e5',
  percentage: 34
}, {
  name: 'Software & Cloud Services',
  value: 540000,
  color: '#10b981',
  percentage: 30
}, {
  name: 'Office Supplies & Equipment',
  value: 290000,
  color: '#8b5cf6',
  percentage: 16
}];
// Payment Aging by Industry Data - Showing deterioration
const paymentAgingData = [{
  industry: 'IT & Technology',
  total: '$620K',
  trades: 18,
  current: 42,
  days1to30: 28,
  days31to60: 18,
  days61to90: 8,
  days91plus: 4
}, {
  industry: 'Software & Cloud Services',
  total: '$540K',
  trades: 12,
  current: 38,
  days1to30: 24,
  days31to60: 22,
  days61to90: 12,
  days91plus: 4
}, {
  industry: 'Office Supplies & Equipment',
  total: '$290K',
  trades: 22,
  current: 48,
  days1to30: 26,
  days31to60: 16,
  days61to90: 7,
  days91plus: 3
}];
export function InitechFinancialsTab() {
  return <div className="space-y-6 mt-6" data-id="element-2095" data-mp="oqrrmikn9n9d">
      {/* Financial Statement Analysis */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-8" data-id="element-2096" data-mp="srtjufg58z1u">
        <div className="flex justify-between items-start mb-8" data-id="element-2097" data-mp="xjbj8z2iqrkp">
          <h2 className="text-xl font-bold text-gray-900" data-id="element-2098" data-mp="xlxsd3525f51">
            Financial Statement Analysis
          </h2>
          <button className="bg-indigo-600 hover:bg-indigo-700 text-white px-5 py-2.5 rounded-lg flex items-center gap-2 font-medium text-sm transition-colors" data-id="element-2099" data-mp="17i12av65ii2j">
            <Upload className="w-4 h-4" data-id="element-2100" data-mp="1ch3w1jgol1v7" />
            UPLOAD FINANCIAL STATEMENT
          </button>
        </div>

        {/* Financial Statement Box */}
        <div className="border border-gray-200 bg-gray-50 rounded-lg p-5 mb-8" data-id="element-2101" data-mp="2rza6w9bf93hr">
          <p className="text-sm font-medium text-gray-500 mb-3 uppercase tracking-wider" data-id="element-2102" data-mp="2n0guylbs9kjp">
            Latest Financial Statement
          </p>
          <div className="flex items-center justify-between bg-white p-4 rounded border border-gray-200 shadow-sm" data-id="element-2103" data-mp="2i2xfji3cn1q6">
            <div className="flex items-center gap-6" data-id="element-2104" data-mp="3fomfp82u79jj">
              <div className="flex items-center gap-3" data-id="element-2105" data-mp="3aprqnoea0oqz">
                <div className="w-10 h-10 bg-indigo-50 rounded-lg flex items-center justify-center" data-id="element-2106" data-mp="3ase4g5rrg0hn">
                  <FileText className="w-5 h-5 text-indigo-600" data-id="element-2107" data-mp="35x89yikaldhy" />
                </div>
                <span className="font-semibold text-gray-900 text-lg" data-id="element-2108" data-mp="31086mfetuouj">
                  Initech-Financial-Statement-2025-Q4
                </span>
              </div>
              <div className="h-6 w-px bg-gray-300" data-id="element-2109" data-mp="3to47lwbfj2x4"></div>
              <div className="flex items-center gap-2 text-gray-600" data-id="element-2110" data-mp="1rrmzi0btu8h5">
                <Calendar className="w-4 h-4" data-id="element-2111" data-mp="1rseupa1ii46w" />
                <span className="font-medium" data-id="element-2112" data-mp="1wr7z8cytmkux">2025</span>
              </div>
              <div className="flex items-center gap-2 text-gray-600" data-id="element-2113" data-mp="1i1tqn732k7gl">
                <Clock className="w-4 h-4" data-id="element-2114" data-mp="1i1jz3f2dls8s" />
                <span className="font-medium" data-id="element-2115" data-mp="1n0dcl7hnxj8y">Q4</span>
              </div>
            </div>
            <div className="flex items-center gap-3" data-id="element-2116" data-mp="191doq21z58du">
              <div className="flex items-center gap-1.5 bg-green-50 px-3 py-1.5 rounded-full border border-green-200" data-id="element-2117" data-mp="18zkj8q33ku7f">
                <CheckCircle2 className="w-4 h-4 text-green-600" data-id="element-2118" data-mp="1d0e3n9hbzqvk" />
                <span className="text-green-700 font-medium text-sm" data-id="element-2119" data-mp="z498sjyq295h">
                  Completed
                </span>
              </div>
              <button className="p-2 hover:bg-gray-100 rounded-full transition-colors" data-id="element-2120" data-mp="143vmeuigpret">
                <ChevronDown className="w-5 h-5 text-gray-500" data-id="element-2121" data-mp="2tew9k8sn593x" />
              </button>
            </div>
          </div>
        </div>

        {/* Ratio Cards - All 5 in one row - POOR RATIOS */}
        <div className="grid grid-cols-1 md:grid-cols-5 gap-4" data-id="element-2122" data-mp="mqm40obk03br">
          {/* Liquidity Ratios - POOR */}
          <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-2123" data-mp="hrsmmkt5bs6b">
            <div className="flex items-center gap-2 mb-4" data-id="element-2124" data-mp="rs32kd6kfdp6">
              <div className="w-8 h-8 bg-blue-50 rounded-lg flex items-center justify-center" data-id="element-2125" data-mp="rqi8sps2rysd">
                <Wallet className="w-4 h-4 text-blue-600" data-id="element-2126" data-mp="15hd7xacrv1ir" />
              </div>
              <h3 className="text-sm font-bold text-gray-900" data-id="element-2127" data-mp="10jboupfcj27a">Liquidity</h3>
            </div>
            <div className="space-y-3" data-id="element-2128" data-mp="1fgck32wqxfai">
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-2129" data-mp="1ffb4cl4sc4mg">
                <span className="text-xs text-gray-600" data-id="element-2130" data-mp="1ag7zb0ot1yeh">Current Ratio</span>
                <span className="font-bold text-sm text-red-600" data-id="element-2131" data-mp="3h9agf8pqeq07">0.92</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-2132" data-mp="3caz48rbys3et">
                <span className="text-xs text-gray-600" data-id="element-2133" data-mp="2qfp6l89mm02f">Quick Ratio</span>
                <span className="font-bold text-sm text-red-600" data-id="element-2134" data-mp="2vete7ugwjpqn">0.68</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-2135" data-mp="305ryt68xb9zp">
                <span className="text-xs text-gray-600" data-id="element-2136" data-mp="308nvkr91bsmk">Working Capital</span>
                <span className="font-bold text-sm text-red-600" data-id="element-2137" data-mp="354l9kqwtsmw6">-$1.2M</span>
              </div>
            </div>
          </div>

          {/* Cash Flow Ratios - NEGATIVE */}
          <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-2138" data-mp="2chifqc33h0c9">
            <div className="flex items-center gap-2 mb-4" data-id="element-2139" data-mp="2heil0ks4dz2b">
              <div className="w-8 h-8 bg-green-50 rounded-lg flex items-center justify-center" data-id="element-2140" data-mp="2lhnn4m8afyqf">
                <DollarSign className="w-4 h-4 text-green-600" data-id="element-2141" data-mp="3svqpt76ohh70" />
              </div>
              <h3 className="text-sm font-bold text-gray-900" data-id="element-2142" data-mp="qwmb9p16618">Cash Flow</h3>
            </div>
            <div className="space-y-3" data-id="element-2143" data-mp="1l8z2q384a75g">
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-2144" data-mp="1l7xf6z9wzs6u">
                <span className="text-xs text-gray-600" data-id="element-2145" data-mp="1h8wz3oitn3nj">Op. Cash Flow</span>
                <span className="font-bold text-sm text-red-600" data-id="element-2146" data-mp="1cgdj6kwnvwfk">-0.42</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-2147" data-mp="17ic56ee3enay">
                <span className="text-xs text-gray-600" data-id="element-2148" data-mp="12j8xsnan44zt">Free Cash Flow</span>
                <span className="font-bold text-sm text-red-600" data-id="element-2149" data-mp="xjmjsbmzmkpy">-$850K</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-2150" data-mp="xlz8d7n93tbz">
                <span className="text-xs text-gray-600" data-id="element-2151" data-mp="tikscgzbbcyj">CF Coverage</span>
                <span className="font-bold text-sm text-red-600" data-id="element-2152" data-mp="ojztolzpl1c7">0.18</span>
              </div>
            </div>
          </div>

          {/* Profitability Ratios - NEGATIVE */}
          <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-2153" data-mp="2iwfw1bpdvvbs">
            <div className="flex items-center gap-2 mb-4" data-id="element-2154" data-mp="2lsim2vhybbwo">
              <div className="w-8 h-8 bg-purple-50 rounded-lg flex items-center justify-center" data-id="element-2155" data-mp="2guh4yg435mnu">
                <TrendingUp className="w-4 h-4 text-purple-600" data-id="element-2156" data-mp="2uu9qlx0r9coy" />
              </div>
              <h3 className="text-sm font-bold text-gray-900" data-id="element-2157" data-mp="2us5mpf2uwdoo">Profitability</h3>
            </div>
            <div className="space-y-3" data-id="element-2158" data-mp="2pt2hnumvm7gp">
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-2159" data-mp="2252u13kv2x6c">
                <span className="text-xs text-gray-600" data-id="element-2160" data-mp="1y4iw3xsgrpj5">Net Margin</span>
                <span className="font-bold text-sm text-red-600" data-id="element-2161" data-mp="1y268b400yky6">-0.12</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-2162" data-mp="2bx8meef0zgm2">
                <span className="text-xs text-gray-600" data-id="element-2163" data-mp="272uitoq7m36b">ROE</span>
                <span className="font-bold text-sm text-red-600" data-id="element-2164" data-mp="1jdidizy06f9a">-0.28</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-2165" data-mp="1ef8eufd2kwix">
                <span className="text-xs text-gray-600" data-id="element-2166" data-mp="3q2tskkggjzh2">Gross Margin</span>
                <span className="font-bold text-sm text-orange-600" data-id="element-2167" data-mp="3uu22dhlp9mur">0.18</span>
              </div>
            </div>
          </div>

          {/* Efficiency Ratios - POOR */}
          <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-2168" data-mp="3h4i52raw1hsu">
            <div className="flex items-center gap-2 mb-4" data-id="element-2169" data-mp="3lze1s4r2ktca">
              <div className="w-8 h-8 bg-orange-50 rounded-lg flex items-center justify-center" data-id="element-2170" data-mp="dn9n87g5uhy4">
                <BarChart3 className="w-4 h-4 text-orange-600" data-id="element-2171" data-mp="hm8p1j6lhylc" />
              </div>
              <h3 className="text-sm font-bold text-gray-900" data-id="element-2172" data-mp="3mpll3oqbbfd">Efficiency</h3>
            </div>
            <div className="space-y-3" data-id="element-2173" data-mp="8m2fg8e0pirg">
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-2174" data-mp="8oygw6p2qpkn">
                <span className="text-xs text-gray-600" data-id="element-2175" data-mp="2ocosraxy9ggx">Inv. Turnover</span>
                <span className="font-bold text-sm text-orange-600" data-id="element-2176" data-mp="2tdvwmywz1vib">3.20</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-2177" data-mp="299op0bmbgdi4">
                <span className="text-xs text-gray-600" data-id="element-2178" data-mp="25ao8x0v83oyt">AR Turnover</span>
                <span className="font-bold text-sm text-orange-600" data-id="element-2179" data-mp="20i4s7v18odps">4.80</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-2180" data-mp="1vk3dfmauj0k4">
                <span className="text-xs text-gray-600" data-id="element-2181" data-mp="1vhqvva902s7l">DSO</span>
                <span className="font-bold text-sm text-red-600" data-id="element-2182" data-mp="1qm1tz09icz84">76.04</span>
              </div>
            </div>
          </div>

          {/* Solvency Ratios - DISTRESS */}
          <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-2183" data-mp="1hj0q76847k7m">
            <div className="flex items-center gap-2 mb-4" data-id="element-2184" data-mp="1cm0r5f9onhq0">
              <div className="w-8 h-8 bg-teal-50 rounded-lg flex items-center justify-center" data-id="element-2185" data-mp="3bxjtvc4e7tr8">
                <Building2 className="w-4 h-4 text-teal-600" data-id="element-2186" data-mp="36z04f1qlbzu4" />
              </div>
              <h3 className="text-sm font-bold text-gray-900" data-id="element-2187" data-mp="36wvyke94sqr7">Solvency</h3>
            </div>
            <div className="space-y-3" data-id="element-2188" data-mp="3egf2m8dmnksa">
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-2189" data-mp="3jgko16tb0b1x">
                <span className="text-xs text-gray-600" data-id="element-2190" data-mp="3o7sw9ziwdqdi">Debt-to-Equity</span>
                <span className="font-bold text-sm text-red-600" data-id="element-2191" data-mp="3t75rb7jxa3r6">3.20</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-2192" data-mp="2vjdljp6stu7z">
                <span className="text-xs text-gray-600" data-id="element-2193" data-mp="30igql9ms40fy">Z-Score</span>
                <span className="font-bold text-sm text-red-600" data-id="element-2194" data-mp="30iqg6w3ww5l4">1.20</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-2195" data-mp="35g9utx4iukdl">
                <span className="text-xs text-gray-600" data-id="element-2196" data-mp="39jetfolhe1wy">Int. Coverage</span>
                <span className="font-bold text-sm text-red-600" data-id="element-2197" data-mp="krm3io20tdji">0.85</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Card Revenue Metrics - DECLINING */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-8" data-id="element-2198" data-mp="nbifx3pxyos9">
        <h2 className="text-xl font-bold text-gray-900 mb-8" data-id="element-2199" data-mp="ndle4b18zo82">
          Card Revenue Metrics
        </h2>

        {/* Summary Stats - More compact layout */}
        <div className="flex flex-wrap justify-between items-center gap-4 mb-6 bg-gray-50 p-4 rounded-lg border border-gray-100" data-id="element-2200" data-mp="xapws0vvx1k4">
          <div className="flex flex-col" data-id="element-2201" data-mp="sd7ugtcdhkl3">
            <span className="text-2xl font-bold text-gray-900 mb-0.5" data-id="element-2202" data-mp="169upuroog2ow">
              $1.2M
            </span>
            <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-2203" data-mp="11ai7ok8r3jsn">
              Annual Card Revenue
            </span>
          </div>
          <div className="w-px h-8 bg-gray-200 hidden md:block" data-id="element-2204" data-mp="1b1csdk6cmbbz"></div>
          <div className="flex flex-col" data-id="element-2205" data-mp="1b24nyuzy4929">
            <span className="text-2xl font-bold text-gray-900 mb-0.5" data-id="element-2206" data-mp="1p0uji674a0oi">
              2.1K
            </span>
            <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-2207" data-mp="1l029haqf7rr6">
              Transactions
            </span>
          </div>
          <div className="w-px h-8 bg-gray-200 hidden md:block" data-id="element-2208" data-mp="23omcmnq2suei"></div>
          <div className="flex flex-col" data-id="element-2209" data-mp="28lmgcrzgdl2g">
            <span className="text-2xl font-bold text-gray-900 mb-0.5" data-id="element-2210" data-mp="28kjp2iy7xgm0">
              $571
            </span>
            <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-2211" data-mp="1zm7phrfdj8hf">
              Avg Ticket Size
            </span>
          </div>
          <div className="w-px h-8 bg-gray-200 hidden md:block" data-id="element-2212" data-mp="1kwjs31abctyz"></div>
          <div className="flex flex-col" data-id="element-2213" data-mp="1pol5wrn4qsr4">
            <span className="text-2xl font-bold text-gray-900 mb-0.5" data-id="element-2214" data-mp="1ppctbf6kpk6b">
              0 - 12
            </span>
            <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-2215" data-mp="1buk8q2bttdsv">
              Daily Transactions
            </span>
          </div>
          <div className="w-px h-8 bg-gray-200 hidden md:block" data-id="element-2216" data-mp="11zih8zu2vzn4"></div>
          <div className="flex flex-col" data-id="element-2217" data-mp="16xamevjqhi99">
            <span className="text-2xl font-bold text-red-600 mb-0.5" data-id="element-2218" data-mp="16w8znttcv7bp">-35%</span>
            <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-2219" data-mp="38mzqkd9u1ybe">
              YoY Growth
            </span>
          </div>
        </div>

        {/* Area Chart - Showing decline */}
        <div className="h-80 w-full" data-id="element-2220" data-mp="2zvh81vpez6f5">
          <ResponsiveContainer width="100%" height="100%" data-id="element-2221" data-mp="2zsblan49cgml">
            <AreaChart data={cardRevenueData} margin={{
            top: 5,
            right: 0,
            left: 0,
            bottom: 0
          }} data-id="element-2222" data-mp="2uwe1u7xp6u5l">
              <defs data-id="element-2223" data-mp="3nki92xvx3fae">
                <linearGradient id="colorRevenue" x1="0" y1="0" x2="0" y2="1" data-id="element-2224" data-mp="3nhw6lcnvvpz1">
                  <stop offset="5%" stopColor="#dc2626" stopOpacity={0.3} data-id="element-2225" data-mp="3ij2o15tqp8s0" />
                  <stop offset="95%" stopColor="#dc2626" stopOpacity={0} data-id="element-2226" data-mp="3dkrgx2utxcdh" />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" data-id="element-2227" data-mp="2771xpmh89ca5" />
              <XAxis dataKey="month" axisLine={true} tickLine={true} tick={{
              fontSize: 12,
              fill: '#6b7280'
            }} interval={3} dy={10} data-id="element-2228" data-mp="1s38u8651yk2p" />
              <YAxis axisLine={true} tickLine={true} tick={{
              fontSize: 12,
              fill: '#6b7280'
            }} domain={[0, 2]} ticks={[0, 0.5, 1, 1.5, 2]} tickFormatter={value => `$${value}M`} data-id="element-2229" data-mp="26s51i0zabt29" />
              <Tooltip formatter={(value: any) => `$${Number(value).toFixed(2)}M`} contentStyle={{
              borderRadius: '8px',
              border: '1px solid #e5e7eb',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              padding: '12px'
            }} data-id="element-2230" data-mp="2krxmrgs1lh2u" />
              <Area type="monotone" dataKey="revenue" stroke="#dc2626" strokeWidth={3} fillOpacity={1} fill="url(#colorRevenue)" activeDot={{
              r: 6,
              fill: '#dc2626',
              stroke: '#fff',
              strokeWidth: 2
            }} data-id="element-2231" data-mp="2x9gt9q5u2qg5" />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* Trade Payment Information */}
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-8" data-id="element-2232" data-mp="29dcpv3qt1id7">
        {/* Trade Credit - DETERIORATING */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6 lg:col-span-2" data-id="element-2233" data-mp="2nddqqj72kpso">
          <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-2234" data-mp="2j8nxl23sppbg">Trade Credit</h2>
          <div className="grid grid-cols-2 gap-x-6 gap-y-4" data-id="element-2235" data-mp="2kk46ytozq4k">
            <div className="flex flex-col border-b border-gray-100 pb-3" data-id="element-2236" data-mp="3upe4kng1ml64">
              <span className="text-2xl font-bold text-gray-900 mb-0.5" data-id="element-2237" data-mp="3urgtt59dga9s">
                $15K
              </span>
              <span className="text-xs font-medium text-gray-500" data-id="element-2238" data-mp="b2m245wrfm8h">
                Recommended Credit Limit
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-3" data-id="element-2239" data-mp="3sbsjq9zb75mp">
              <span className="text-2xl font-bold text-red-600 mb-0.5" data-id="element-2240" data-mp="13wh449khlo0">45</span>
              <span className="text-xs font-medium text-gray-500" data-id="element-2241" data-mp="ou0jy9exlhdy">
                Days Beyond Terms
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-3" data-id="element-2242" data-mp="ts25d0ztxssl">
              <span className="text-xl font-bold text-gray-900 mb-0.5" data-id="element-2243" data-mp="f4qtexzqk6ry">70</span>
              <span className="text-xs font-medium text-gray-500" data-id="element-2244" data-mp="k3agj1q2folw">
                Trade Experiences
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-3" data-id="element-2245" data-mp="17rtpljgxw5f1">
              <span className="text-xl font-bold text-gray-900 mb-0.5" data-id="element-2246" data-mp="1cjbgtft5urmt">
                $1.81M
              </span>
              <span className="text-xs font-medium text-gray-500" data-id="element-2247" data-mp="344fmskh2a139">
                Total Trades Balance
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-3" data-id="element-2248" data-mp="392z6sfc3h2sz">
              <span className="text-xl font-bold text-gray-900 mb-0.5" data-id="element-2249" data-mp="2ue328s98y7x4">
                $95K
              </span>
              <span className="text-xs font-medium text-gray-500" data-id="element-2250" data-mp="2zcea4xfze8cp">
                Recent High Credit
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-3" data-id="element-2251" data-mp="2pft3y8s86r7a">
              <span className="text-xl font-bold text-gray-900 mb-0.5" data-id="element-2252" data-mp="2pdoulbbk4zzm">
                $25.9K
              </span>
              <span className="text-xs font-medium text-gray-500" data-id="element-2253" data-mp="2gf3fjq5ao33l">
                Average Credit Amount
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-3" data-id="element-2254" data-mp="9potwmtdi7z8">
              <span className="text-xl font-bold text-red-600 mb-0.5" data-id="element-2255" data-mp="eo9vapkd2xp9">
                $700K
              </span>
              <span className="text-xs font-medium text-gray-500" data-id="element-2256" data-mp="1z4zkourd98u5">
                Past Due
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-3" data-id="element-2257" data-mp="1u88zxu4m9p2e">
              <span className="text-xl font-bold text-red-600 mb-0.5" data-id="element-2258" data-mp="28wne317hgzy9">
                38.7%
              </span>
              <span className="text-xs font-medium text-gray-500" data-id="element-2259" data-mp="2443spi2k10iw">
                Past Due %
              </span>
            </div>
            <div className="flex flex-col" data-id="element-2260" data-mp="2hy3dyf0o9jo8">
              <span className="text-xl font-bold text-red-600 mb-0.5" data-id="element-2261" data-mp="2cxyzeujbqz0n">
                $280K
              </span>
              <span className="text-xs font-medium text-gray-500" data-id="element-2262" data-mp="2rt54nfalitsx">
                Severely Past Due
              </span>
            </div>
            <div className="flex flex-col" data-id="element-2263" data-mp="2mtiqn3my19j2">
              <span className="text-xl font-bold text-red-600 mb-0.5" data-id="element-2264" data-mp="xfnfxoygfqwb">
                15.5%
              </span>
              <span className="text-xs font-medium text-gray-500" data-id="element-2265" data-mp="singvy00voep">
                Severely Past Due %
              </span>
            </div>
          </div>
        </div>

        {/* Days Beyond Terms Chart - SPIKING */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6 flex flex-col lg:col-span-3" data-id="element-2266" data-mp="1m7ct5xyto6e3">
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start mb-3 gap-3" data-id="element-2267" data-mp="1r88ty2nvncfa">
            <h2 className="text-xl font-bold text-gray-900" data-id="element-2268" data-mp="1w3663igge1we">
              Days Beyond Terms
            </h2>
            <div className="flex flex-wrap items-center gap-3 text-xs bg-gray-50 px-3 py-1.5 rounded-lg border border-gray-100" data-id="element-2269" data-mp="255xibkh5l1p3">
              <div className="flex items-center gap-2" data-id="element-2270" data-mp="29wduz2d5gjae">
                <div className="w-5 h-0.5 border-t-2 border-dashed border-gray-400" data-id="element-2271" data-mp="29yqkc0l8lvxh"></div>
                <span className="font-medium text-gray-600" data-id="element-2272" data-mp="2exuv2vnt81px">Industry</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-2273" data-mp="2jwo86mz6pqpk">
                <div className="w-5 h-0.5 bg-gray-900" data-id="element-2274" data-mp="2ot4ynntuwh5t"></div>
                <span className="font-medium text-gray-900" data-id="element-2275" data-mp="2ork1dqg5qk49">DBT</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-2276" data-mp="d4hyyj7wz7b6">
                <div className="w-5 h-0.5 bg-red-600" data-id="element-2277" data-mp="86gf3w2nz3yn"></div>
                <span className="font-medium text-red-600" data-id="element-2278" data-mp="38eyriwmhiqv">Your AR</span>
              </div>
            </div>
          </div>
          <p className="text-xs text-gray-500 mb-6 max-w-md leading-relaxed" data-id="element-2279" data-mp="3uf80cnvbvjvx">
            Payment behavior has severely deteriorated over the past year, with
            DBT spiking from 15 to 45 days.
          </p>
          <div className="flex-1 min-h-[250px] w-full mt-auto" data-id="element-2280" data-mp="qz0ty9lj38jg">
            <ResponsiveContainer width="100%" height="100%" data-id="element-2281" data-mp="m6zkevfqvvx4">
              <LineChart data={dbtData} margin={{
              top: 5,
              right: 10,
              left: -20,
              bottom: 0
            }} data-id="element-2282" data-mp="m5g63adnfuxz">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" data-id="element-2283" data-mp="19wty1f7w1oif" />
                <XAxis dataKey="month" axisLine={true} tickLine={true} tick={{
                fontSize: 12,
                fill: '#6b7280'
              }} dy={10} data-id="element-2284" data-mp="ud96dsc99djp" />
                <YAxis axisLine={true} tickLine={true} tick={{
                fontSize: 12,
                fill: '#6b7280'
              }} domain={[0, 50]} ticks={[0, 10, 20, 30, 40, 50]} data-id="element-2285" data-mp="pgiqp64d4jyt" />
                <Tooltip contentStyle={{
                borderRadius: '8px',
                border: '1px solid #e5e7eb',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                padding: '12px'
              }} data-id="element-2286" data-mp="13ez3nestj6pe" />
                <Line type="monotone" dataKey="industry" name="Industry" stroke="#9ca3af" strokeWidth={2} strokeDasharray="5 5" dot={false} activeDot={{
                r: 6,
                fill: '#9ca3af'
              }} data-id="element-2287" data-mp="20wh4fnahju6d" />
                <Line type="monotone" dataKey="dbt" name="DBT" stroke="#111827" strokeWidth={2} dot={false} activeDot={{
                r: 6,
                fill: '#111827'
              }} data-id="element-2288" data-mp="3qcjq13u94oqi" />
                <Line type="monotone" dataKey="yourAR" name="Your AR" stroke="#dc2626" strokeWidth={3} dot={false} activeDot={{
                r: 6,
                fill: '#dc2626'
              }} data-id="element-2289" data-mp="37ls8hf041s11" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      {/* Trade Payment Aging - SEVERELY PAST DUE */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-8" data-id="element-2290" data-mp="3pnfu8hd3ljcr">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-8 gap-4" data-id="element-2291" data-mp="3tpkjl3wijttl">
          <div data-id="element-2292" data-mp="3tn82su2hrpi4">
            <h2 className="text-xl font-bold text-gray-900 mb-2" data-id="element-2293" data-mp="2wzk0nlits7k7">
              Trade Payment Information
            </h2>
            <div className="flex items-center gap-3 text-sm" data-id="element-2294" data-mp="31zg4nkrivyzr">
              <span className="font-medium text-gray-900 bg-gray-100 px-2.5 py-1 rounded-md" data-id="element-2295" data-mp="36002kqjx76my">
                Total Trade Lines: 70
              </span>
              <span className="text-gray-500" data-id="element-2296" data-mp="3arhz92ewul24">
                Updated Monthly - Next Update 04/01/2026
              </span>
            </div>
          </div>
        </div>

        {/* Table - Showing severe past due */}
        <div className="overflow-x-auto mb-10 border border-gray-200 rounded-xl" data-id="element-2297" data-mp="2i8kra8a61ezk">
          <table className="w-full text-left border-collapse" data-id="element-2298" data-mp="2aqcx8vppkoy1">
            <thead data-id="element-2299" data-mp="25ra52butud7h">
              <tr className="bg-gray-50 border-b border-gray-200" data-id="element-2300" data-mp="25suujn2ab5yh">
                <th className="px-6 py-4 text-sm font-bold text-gray-900" data-id="element-2301" data-mp="21pycbxgnpbv2">
                  Status
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right" data-id="element-2302" data-mp="1wq24fn4u90a8">
                  Current
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right" data-id="element-2303" data-mp="1rtbr37kf4isi">
                  1-30
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right" data-id="element-2304" data-mp="1i27c47uqsxxo">
                  31-60
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right" data-id="element-2305" data-mp="1e1f2velvet1e">
                  61-90
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right" data-id="element-2306" data-mp="190zm0d2dr3eo">
                  91+
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right bg-gray-100" data-id="element-2307" data-mp="144sjyvd3uc20">
                  Total
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-2308" data-mp="2ww4l99oizgbx">
              <tr className="hover:bg-gray-50/50 transition-colors" data-id="element-2309" data-mp="2iz90wl2tq2gk">
                <td className="px-6 py-4 text-sm font-medium text-gray-900" data-id="element-2310" data-mp="2nxaggw11jjna">
                  Paid
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-2311" data-mp="298ead4ijogpb">
                  $3,200,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-2312" data-mp="2e04nfi8v9ikf">
                  $1,800,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-2313" data-mp="205vc6xppes9e">
                  $950,000
                </td>
                <td className="px-6 py-4 text-sm text-orange-600 text-right" data-id="element-2314" data-mp="1qa20fgjt72so">
                  $620,000
                </td>
                <td className="px-6 py-4 text-sm text-red-600 text-right" data-id="element-2315" data-mp="1v94y2fxgm6qm">
                  $430,000
                </td>
                <td className="px-6 py-4 text-sm font-bold text-gray-900 text-right bg-gray-50" data-id="element-2316" data-mp="1bnlg5d95k70n">
                  $7,000,000
                </td>
              </tr>
              <tr className="hover:bg-gray-50/50 transition-colors" data-id="element-2317" data-mp="1llsm711wl4nv">
                <td className="px-6 py-4 text-sm font-medium text-gray-900" data-id="element-2318" data-mp="1liwo9cq22fzf">
                  Outstanding
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-2319" data-mp="1ulfp5raa6ij1">
                  $280,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-2320" data-mp="1pm2z6xo44vc8">
                  $350,000
                </td>
                <td className="px-6 py-4 text-sm text-orange-600 text-right" data-id="element-2321" data-mp="24az8sz5tigey">
                  $480,000
                </td>
                <td className="px-6 py-4 text-sm text-red-600 text-right" data-id="element-2322" data-mp="2dcf5y57mgm18">
                  $420,000
                </td>
                <td className="px-6 py-4 text-sm text-red-600 text-right font-bold" data-id="element-2323" data-mp="29bdcy64at67p">
                  $280,000
                </td>
                <td className="px-6 py-4 text-sm font-bold text-gray-900 text-right bg-gray-50" data-id="element-2324" data-mp="3ap0g4gdwzcjq">
                  $1,810,000
                </td>
              </tr>
              <tr className="hover:bg-gray-50/50 transition-colors" data-id="element-2325" data-mp="30qta2sl5yewi">
                <td className="px-6 py-4 text-sm font-medium text-gray-900" data-id="element-2326" data-mp="2wprc0f2zg8w4">
                  Payment Experiences
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-2327" data-mp="2rqxv0cohlzr7">
                  28
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-2328" data-mp="2mz66e7ow643p">
                  18
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-2329" data-mp="2i14klf02zqoj">
                  12
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-2330" data-mp="2czxf5mlev3l1">
                  8
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-2331" data-mp="241bzq0b8k4oh">
                  4
                </td>
                <td className="px-6 py-4 text-sm font-bold text-gray-900 text-right bg-gray-50" data-id="element-2332" data-mp="jjueqkamvvtb">
                  70
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Bar Charts */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-2333" data-mp="sk90tlvf9exv">
          {/* Paid Chart */}
          <div className="bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-2334" data-mp="xiajw6sule9c">
            <h3 className="text-lg font-bold text-gray-900 mb-6 flex items-center gap-2" data-id="element-2335" data-mp="tl2ehl4unnw">
              <div className="w-2 h-6 bg-green-600 rounded-full" data-id="element-2336" data-mp="4tdf96hk7fz2"></div>
              Paid History
            </h3>
            <div className="h-64 w-full" data-id="element-2337" data-mp="9s6rkvl410xn">
              <ResponsiveContainer width="100%" height="100%" data-id="element-2338" data-mp="9rewdlvfd57w">
                <BarChart data={paidData} margin={{
                top: 5,
                right: 10,
                left: 0,
                bottom: 0
              }} data-id="element-2339" data-mp="ekq5xurmg03i">
                  <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" data-id="element-2340" data-mp="pekw4jniuy3f" />
                  <XAxis dataKey="name" axisLine={true} tickLine={true} tick={{
                  fontSize: 12,
                  fill: '#6b7280'
                }} dy={10} data-id="element-2341" data-mp="kf813bmhykpr" />
                  <YAxis axisLine={true} tickLine={true} tick={{
                  fontSize: 12,
                  fill: '#6b7280'
                }} tickFormatter={value => `$${value / 1000000}M`} data-id="element-2342" data-mp="6ht5fp5nhgpc" />
                  <Tooltip formatter={(value: any) => `$${(value / 1000000).toFixed(1)}M`} contentStyle={{
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                  padding: '12px'
                }} cursor={{
                  fill: '#e5e7eb',
                  opacity: 0.4
                }} data-id="element-2343" data-mp="ajn27mcq60k8" />
                  <Bar dataKey="value" radius={[4, 4, 0, 0]} shape={(props: any) => {
                  const {
                    x,
                    y,
                    width,
                    height,
                    name
                  } = props;
                  let fill = '#16a34a';
                  if (name === '1-30') fill = '#84cc16';
                  if (name === '31-60') fill = '#facc15';
                  if (name === '61-90') fill = '#f59e0b';
                  if (name === '91+') fill = '#dc2626';
                  return <rect x={x} y={y} width={width} height={height} fill={fill} rx={4} ry={4} data-id="element-2345" data-mp="2w10f6ldow3pe" />;
                }} data-id="element-2344" data-mp="1pewsxtteycrh" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>

          {/* Outstanding Chart */}
          <div className="bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-2346" data-mp="yaamwg4ge0uj">
            <h3 className="text-lg font-bold text-gray-900 mb-6 flex items-center gap-2" data-id="element-2347" data-mp="1vuwwy0eg0a91">
              <div className="w-2 h-6 bg-blue-600 rounded-full" data-id="element-2348" data-mp="1qx56zbxcyy7h"></div>
              Outstanding Balance
            </h3>
            <div className="h-64 w-full" data-id="element-2349" data-mp="1m3tuau5v7n7n">
              <ResponsiveContainer width="100%" height="100%" data-id="element-2350" data-mp="1h7brhzu3hyxy">
                <BarChart data={outstandingData} margin={{
                top: 5,
                right: 10,
                left: 0,
                bottom: 0
              }} data-id="element-2351" data-mp="1h4ze7zza8cr8">
                  <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" data-id="element-2352" data-mp="2h7p0n3h34bfg" />
                  <XAxis dataKey="name" axisLine={true} tickLine={true} tick={{
                  fontSize: 12,
                  fill: '#6b7280'
                }} dy={10} data-id="element-2353" data-mp="2r53aulcf03zb" />
                  <YAxis axisLine={true} tickLine={true} tick={{
                  fontSize: 12,
                  fill: '#6b7280'
                }} tickFormatter={value => `$${value / 1000}K`} data-id="element-2354" data-mp="3542ufel2lsom" />
                  <Tooltip formatter={(value: any) => `$${(value / 1000).toFixed(0)}K`} contentStyle={{
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                  padding: '12px'
                }} cursor={{
                  fill: '#e5e7eb',
                  opacity: 0.4
                }} data-id="element-2355" data-mp="3jua7fesb6jhx" />
                  <Bar dataKey="value" radius={[4, 4, 0, 0]} shape={(props: any) => {
                  const {
                    x,
                    y,
                    width,
                    height,
                    name
                  } = props;
                  let fill = '#16a34a';
                  if (name === '1-30') fill = '#84cc16';
                  if (name === '31-60') fill = '#facc15';
                  if (name === '61-90') fill = '#f59e0b';
                  if (name === '91+') fill = '#dc2626';
                  return <rect x={x} y={y} width={width} height={height} fill={fill} rx={4} ry={4} data-id="element-2357" data-mp="m5k22rg7adfv" />;
                }} data-id="element-2356" data-mp="1sr4fcrst0qbw" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
      </div>

      {/* Trade Spend by Industry Section */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-2358" data-mp="3keudvw7mykpz">
        {/* Trade Spend Donut Chart */}
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-8 lg:col-span-1" data-id="element-2359" data-mp="3peykmuiqs130">
          <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-2360" data-mp="3bf78z0fp6ws6">
            Trade Spend by Industry
          </h2>
          <div className="relative h-64 w-full mb-8" data-id="element-2361" data-mp="3ges9vgefhf7j">
            <ResponsiveContainer width="100%" height="100%" data-id="element-2362" data-mp="3gfli6lt1ccrs">
              <PieChart data-id="element-2363" data-mp="19om0fof5iqng">
                <Pie data={tradeSpendData} cx="50%" cy="50%" innerRadius={70} outerRadius={100} paddingAngle={2} dataKey="value" stroke="none" data-id="element-2364" data-mp="19l7y2g6hmhg0">
                  {tradeSpendData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-2365" data-mp="2dfp1jvgfhot3" data-mpi={index} />)}
                </Pie>
                <Tooltip formatter={(value: any) => `$${(value / 1000).toFixed(0)}K`} contentStyle={{
                borderRadius: '8px',
                border: '1px solid #e5e7eb',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
              }} data-id="element-2366" data-mp="29ewqcwnzx9u6" />
              </PieChart>
            </ResponsiveContainer>
            <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none" data-id="element-2367" data-mp="1qhvi92z5atm0">
              <span className="text-2xl font-black text-gray-900" data-id="element-2368" data-mp="3ovn7hqgb7uq3">$1.81M</span>
              <span className="text-sm font-medium text-gray-500" data-id="element-2369" data-mp="3kvmnzrecstc6">
                Total Spend
              </span>
            </div>
          </div>

          {/* Custom Legend */}
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-3" data-id="element-2370" data-mp="1bl3uajgrukek">
            {tradeSpendData.map((item, index) => <div key={index} className="flex items-center gap-2" data-id="element-2371" data-mp="1gdx1rf3mk6uc" data-mpi={index}>
                <div className="w-3 h-3 rounded-full" style={{
              backgroundColor: item.color
            }} data-id="element-2372" data-mp="1keqpo8h2hln8"></div>
                <span className="text-sm text-gray-600" data-id="element-2373" data-mp="smj5iy2crr43">
                  {item.name} {item.percentage}%
                </span>
              </div>)}
          </div>
        </div>

        {/* Payment Aging by Industry */}
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-8 lg:col-span-2" data-id="element-2374" data-mp="11oinptp3t18m">
          <div className="flex justify-between items-center mb-8" data-id="element-2375" data-mp="28304urjrzb5e">
            <h2 className="text-xl font-bold text-gray-900" data-id="element-2376" data-mp="2d2d0a0oppqjl">
              Payment Aging by Industry
            </h2>
            <div className="flex bg-gray-100 rounded-lg p-1" data-id="element-2377" data-mp="2agl2w701vjql">
              <button className="px-3 py-1 text-sm font-medium bg-white shadow-sm rounded-md text-gray-900" data-id="element-2378" data-mp="2femlyrxh7j22">
                %
              </button>
              <button className="px-3 py-1 text-sm font-medium text-gray-500 hover:text-gray-900" data-id="element-2379" data-mp="2jfg4t6w2a7o3">
                $
              </button>
            </div>
          </div>

          <div className="space-y-6" data-id="element-2380" data-mp="2tf74dmzhbcv1">
            {paymentAgingData.map((item, index) => <div key={index} className="flex flex-col gap-2" data-id="element-2381" data-mp="2ycyrm3p6iasw" data-mpi={index}>
                <div className="flex justify-between items-end" data-id="element-2382" data-mp="2yb5lcpih9slf">
                  <span className="text-sm font-medium text-gray-700" data-id="element-2383" data-mp="334qn8sn6z6pw">
                    {item.industry}
                  </span>
                  <span className="text-sm text-gray-500" data-id="element-2384" data-mp="377n002q1w8lx">
                    {item.total} ({item.trades})
                  </span>
                </div>
                {/* Stacked Bar */}
                <div className="h-6 w-full flex rounded-sm overflow-hidden" data-id="element-2385" data-mp="3h1vqylzfnthz">
                  {item.current > 0 && <div style={{
                width: `${item.current}%`
              }} className="bg-[#16a34a] h-full flex items-center justify-center border-r border-white/20 last:border-0" data-id="element-2386" data-mp="3m8tt7bnya77g">
                      {item.current > 10 && <span className="text-[10px] font-bold text-white" data-id="element-2387" data-mp="dta3unqeh8xo">
                          {item.current}%
                        </span>}
                    </div>}
                  {item.days1to30 > 0 && <div style={{
                width: `${item.days1to30}%`
              }} className="bg-[#84cc16] h-full flex items-center justify-center border-r border-white/20 last:border-0" data-id="element-2388" data-mp="40uo7x2kswfy">
                      {item.days1to30 > 10 && <span className="text-[10px] font-bold text-white" data-id="element-2389" data-mp="2m0dkih861ew3">
                          {item.days1to30}%
                        </span>}
                    </div>}
                  {item.days31to60 > 0 && <div style={{
                width: `${item.days31to60}%`
              }} className="bg-[#facc15] h-full flex items-center justify-center border-r border-white/20 last:border-0" data-id="element-2390" data-mp="2c8zowkjc4z88">
                      {item.days31to60 > 10 && <span className="text-[10px] font-bold text-white" data-id="element-2391" data-mp="1tcrj9fmeumce">
                          {item.days31to60}%
                        </span>}
                    </div>}
                  {item.days61to90 > 0 && <div style={{
                width: `${item.days61to90}%`
              }} className="bg-[#f59e0b] h-full flex items-center justify-center border-r border-white/20 last:border-0" data-id="element-2392" data-mp="3no669oo1e7og">
                      {item.days61to90 > 10 && <span className="text-[10px] font-bold text-white" data-id="element-2393" data-mp="1qrthrrkn2o2x">
                          {item.days61to90}%
                        </span>}
                    </div>}
                  {item.days91plus > 0 && <div style={{
                width: `${item.days91plus}%`
              }} className="bg-[#dc2626] h-full flex items-center justify-center border-r border-white/20 last:border-0" data-id="element-2394" data-mp="1vqmydsv82v7b">
                      {item.days91plus > 10 && <span className="text-[10px] font-bold text-white" data-id="element-2395" data-mp="fblf7q57jcr9">
                          {item.days91plus}%
                        </span>}
                    </div>}
                </div>
              </div>)}
          </div>

          <div className="mt-8 text-center border-t border-gray-100 pt-4" data-id="element-2396" data-mp="gt0r9cofcgp4">
            <button className="text-indigo-600 text-sm font-medium hover:text-indigo-700 uppercase tracking-wider" data-id="element-2397" data-mp="lsn5npfzo2zi">
              Show More
            </button>
          </div>
        </div>
      </div>
    </div>;
}